export default __webpack_public_path__ + "static/media/customer-satisfaction.429020a4.jpeg";